import simg1 from '../images/services/icon-1.svg'
import simg2 from '../images/services/icon-2.svg'
import simg3 from '../images/services/icon-3.svg'
import simg4 from '../images/services/icon-4.svg'

import sSimg1 from '../images/service-single/1.jpg'
import sSimg2 from '../images/service-single/2.jpg'
import sSimg3 from '../images/service-single/3.jpg'
import sSimg4 from '../images/service-single/4.jpg'




const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      title: 'Business Process Automation',
      slug: '1',
      description: 'We help organizations automate repetitive tasks & boost productivity while improving customer satisfaction.',
   },
   {
      Id: '02',
      sImg: simg2,
      sSImg: sSimg2,
      title: 'Solution Architecture',
      slug: '2',
      description: 'Our experts create scalable, secure, and efficient solution designs tailored to business needs, ensuring seamless implementation.',
   },
   {
      Id: '03',
      sImg: simg3,
      sSImg: sSimg3,
      title: 'Support & Maintenance',
      slug: '3',
      description: 'End-to-end support and maintenance services to minimize downtime, optimize performance, and ensure business continuity.',
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      title: 'Big Data Applications',
      slug: '4',
      description: 'Unlock the power of data with advanced Big Data solutions that deliver insights, improve decision-making,drive innovation.',
   },
   // {
   //    Id: '05',
   //     sImg: simg2,
   //    sSImg: sSimg2,
   //    title: 'Java Development',
   //    slug: '5',
   //    description: 'From enterprise software to mobile apps, our Java specialists build robust applications that drive efficiency and innovation.',
   // },
   // {
   //    Id: '06',
   //     sImg: simg1,
   //    sSImg: sSimg1,
   //    title: 'IT Consulting',
   //    slug: '6',
   //    description: 'Strategic consulting to assess your IT landscape, define the right technologies, and implement solutions that accelerate growth.',
   // },
   // {
   //    Id: '07',
   //     sImg: simg3,
   //    sSImg: sSimg3,
   //    title: 'Artificial Intelligence',
   //    slug: '6',
   //    description: 'Leverage AI to transform your business with intelligent automation, and smart solutions that enhance efficiency.',
   // },
   // {
   //    Id: '08',
   //    sImg: simg4,
   //    sSImg: sSimg4,
   //    title: 'Quality Assurance',
   //    slug: '6',
   //    description: 'Comprehensive QA and testing services to ensure high performance, delivering flawless software experiences to customers.',
   // },
 
]

export default Services;